export default "__VITE_ASSET__BhpBlvza__"